<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { MODAL_TABS } from '../../constants';
    import { exitUrl, hideHomeButton } from '@src/store/misc';
    // icons
    import HomeIcon from '@src/assets/icons/icon_home.svg';
    import SettingsIcon from '@src/assets/icons/icon_settings.svg';
    import InfoIcon from '@src/assets/icons/icon_info.svg';

    const dispatch = createEventDispatcher();

    export let iconClass;
    export let currentTab;
</script>

<div class="flex w-full items-center">
    {#if !$hideHomeButton}
        <a href={$exitUrl} target="_top" class={iconClass}>
            <HomeIcon />
        </a>
    {/if}

    <div class="flex w-full items-center justify-end gap-x-6 tablet:gap-x-8">
        <div
            class={iconClass}
            class:cross-modal-menu-navigation-active-tab={currentTab === MODAL_TABS.INFO}
            on:click={() => dispatch('tab_info')}
        >
            <InfoIcon />
        </div>
        <div
            class={iconClass}
            class:cross-modal-menu-navigation-active-tab={currentTab === MODAL_TABS.SETTINGS}
            on:click={() => dispatch('tab_setting')}
        >
            <SettingsIcon />
        </div>
    </div>
    <slot />
</div>
